<div class="page">
  <div class="page__container">
    <h1 class="page__title h2">{{ 'shop_purchase_title' | translate }}</h1>
    <div class="row mt-5">
      <div class="col-12 mb-4">
        <div class="tst-success p-2 mb-1">
          <div class="d-flex">
            <img class="tst-icon" src="assets/images/icons/icon-success.svg" />
            <div>
              <div class="tst-title" translate>shop_purchase_success_title</div>
              <div class="tst-text mt-2" [innerHtml]="'shop_purchase_success' | translate"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-12 mb-4">
        <wsb-atlas-button variant="tertiary" class="mb-2" [label]="'shop_purchase_gotodashboard'" routerLink="/">{{
          'shop_purchase_gotodashboard' | translate
        }}</wsb-atlas-button>
      </div>
    </div>
  </div>
</div>
